import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
export default function HomeFaqs() {
  const [openIndex, setOpenIndex] = useState(0);
  const faqs = [
    {
      q: "What type of homes are available at Aura by Tranquillo?",
      a: "Aura by Tranquillo offers spacious 2 BHK apartments designed for comfortable modern family living. Each home is planned with a 1050 sq. ft. layout and is part of a secure gated community.",
    },
    {
      q: "Where is Aura by Tranquillo located?",
      a: "Aura by Tranquillo is located in Nandigaon, Patancheru. The location provides access to the Outer Ring Road, schools, hospitals, everyday conveniences and major employment destinations.",
    },
    {
      q: "What are the key project features?",
      a: "Aura is planned across 2.3 acres with 4 blocks and 210 units. The project features a clubhouse, kids' play areas, designer landscaping, indoor games and a 24/7 secured community.",
    },
    {
      q: "Is Aura by Tranquillo RERA Registered?",
      a: "Yes, Aura by Tranquillo is RERA Registered and HMDA Approved. The project details also mention that an Occupancy Certificate (OC) has been received.",
    },
    {
      q: "What amenities are available at Aura by Tranquillo?",
      a: "Aura offers a range of amenities designed for comfortable community living, including a clubhouse, kids' play areas, designer landscaping and indoor games. The community also provides 24/7 security and dedicated parking facilities for residents.",
    },
    {
      q: "What are the nearby schools and educational institutions?",
      a: "Several educational institutions are located around Aura, including The Gaudium School, Rainbow International School, International School of Hyderabad and Sancta Maria International School. Other institutions listed nearby include University of Hyderabad, Oakdale International School and Samashti International School.",
    },
    {
      q: "What sustainability features are included at Aura by Tranquillo?",
      a: "Aura incorporates features such as rainwater harvesting, optimized ventilation, water conservation and renewable energy to support sustainable living. The project also includes low-VOC materials, efficient water management and solid waste management practices.",
    },
    {
      q: "Is Aura by Tranquillo close to Hyderabad's IT and employment hubs?",
      a: "Aura offers connectivity to important employment and business destinations around Hyderabad. Financial District, Gachibowli Cross Road, TSIIC Hub and Hindalco Industries Ltd. are among the destinations listed in the location section.",
    },
  ];
  return (
    <div id="specifications">
      <section className="bg-white py-10 xl:py-16 xl:px-[50px] relative overflow-hidden shape">
        <div className="max-w-screen-xl mx-auto lg:px-6 text-center relative">
          <h3 className="font-crimson text-3xl xl:text-5xl px-4 text-[#5e3920] pb-10">
           Frequently Asked Questions About Aura by Tranquillo
          </h3>

          <div className=" px-5 xl:px-0 pb-8">
            <div className="lg:col-span-7 space-y-4">
              {faqs.map((faq, idx) => {
                const isOpen = openIndex === idx;
                return (
                  <div
                    key={idx}
                    className={`border rounded-2xl transition-all duration-200 overflow-hidden ${
                      isOpen
                        ? "bg-[#fdf6f6] border-[#5e3920] shadow-sm"
                        : "bg-[#fdf6f6] border-[#fdf6f6] hover:border-[#5e3920]"
                    }`}
                  >
                    <button
                      onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                      className="w-full md:p-6 p-4 text-left flex items-center justify-between gap-4 transition-colors"
                    >
                      <span className="text-xl sm:text-base font-semibold text-[#5e3920] tracking-tight">
                        Q{idx + 1}. {faq.q}
                      </span>
                      <div
                        className={`h-8 w-8 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                          !isOpen
                            ? "bg-[#c55b12] text-white"
                            : "bg-[#5e3920] text-white"
                        }`}
                      >
                        {!isOpen ? <AddIcon /> : <RemoveIcon />}
                      </div>
                    </button>

                    {isOpen && (
                      <div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25, ease: "easeInOut" }}
                      >
                        <div className="xl:px-6 px-4 pb-6 mb-2   border-t border-slate-100 text-[#000000d9] text-[14px] md:text-base leading-relaxed font-inter text-left line-clamp-4">
                          {faq.a}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
